import { HTTP_TIMEOUT_ERROR_NAME } from '@federa/const/http-error-codes';

export function isTimeoutError(error: unknown): boolean {
	return error instanceof Error && error.name === HTTP_TIMEOUT_ERROR_NAME;
}

/** On timeout, swallow the unawaited fetch rejection so it does not surface as an unhandled rejection. */
export function handleTimeoutError(error: unknown, fetchPromise: Promise<Response> | undefined): void {
	if (isTimeoutError(error) && fetchPromise) fetchPromise.catch(() => {});
}
